// Whether a key press belongs to a place where the person is typing: a text field, a text
// area, a select or an editor (contenteditable). App-wide shortcuts leave those keys alone,
// so Ctrl+Z there undoes the typing instead of the last change to a task.
const NON_TEXT_INPUTS = new Set(['button', 'checkbox', 'radio', 'range', 'color', 'file', 'submit', 'reset', 'image']);

export function isTypingTarget(target) {
  const el = target && target.nodeType === 1 ? target : target?.parentElement;
  if (!el) return false;
  if (el.isContentEditable || el.closest?.('[contenteditable="true"], [contenteditable=""]')) return true;
  const tag = el.tagName;
  if (tag === 'TEXTAREA' || tag === 'SELECT') return true;
  if (tag === 'INPUT') return !NON_TEXT_INPUTS.has((el.getAttribute('type') || 'text').toLowerCase());
  return false;
}
